module.exports = __webpack_public_path__ + "img/share-hand.7d126f65.png";